export const dataURItoBlob = dataURI => {
  var binary = atob(dataURI.split(',')[1]);
  var array: Array<any> = [];
  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
};

export const openUrlInNewTab = url => window.open(url, '_blank');
